import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

import {AccordionModule} from 'ngx-bootstrap/accordion';
import {AlertModule} from 'ngx-bootstrap/alert';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {ProgressbarModule} from 'ngx-bootstrap/progressbar';
import {RatingModule} from 'ngx-bootstrap/rating';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
//import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
//import { DragDropModule } from '@angular/cdk/drag-drop';
import {FlotDirective} from './directives/flot/flot.directive';
import {SparklineDirective} from './directives/sparkline/sparkline.directive';

import {ColorsService} from './colors/colors.service';
import {CheckallDirective} from './directives/checkall/checkall.directive';
import {VectormapDirective} from './directives/vectormap/vectormap.directive';
import {NowDirective} from './directives/now/now.directive';
import {ScrollableDirective} from './directives/scrollable/scrollable.directive';
import {JqcloudDirective} from './directives/jqcloud/jqcloud.directive';
import {SortByKeyPipe} from './pipes/sort-by-key.pipe';
import {ImagePreview} from './directives/image-preview/image-preview.directive';
import {ToggleButtonComponent} from './toggle-button/toggle-button.component';
import {CompanySelectComponent} from './company-select/company-select.component';
import {NgSelectModule} from "@ng-select/ng-select";
import {ListSelectComponent} from "./list-select/list-select.component";
import {NonEmptyListValidatorDirective} from "./validators/non-empty-list.directive";
import {NominativeSelectComponent} from "./nominative-select/nominative-select.component";
import {HeadquarterSelectComponent} from "./headquarter-select/headquarter-select.component";
import {VatRateSelectComponent} from "./vat-rate-select/vat-rate-select.component";
import {PaymentSelectComponent} from "./payment-select/payment-select.component";
import {ItemSelectComponent} from "./item-select/item-select.component";
import {EmailFormComponent} from "./email-form/email-form.component";
import {NoteRegistrationComponent} from "./note-registration/note-registration.component";
import {UploaderComponent} from "./uploader/uploader.component";
import {StdDialogComponent} from "./std-dialog/std-dialog.component";
import {ProjectSelectComponent} from "./project-select/project-select.component";
import {EnumSelectComponent} from "./enum-select/enum-select.component";
import { PageHeaderComponent } from './page-header/page-header.component';
import {SpecificationsBuyerSelectComponent} from "./specifications-buyer-select/specifications-buyer-select.component";
import {SpecificationsItemSelectComponent} from "./specifications-item-select/specifications-item-select.component";
import {CustOrderSelectComponent} from "./cust-order-select/cust-order-select.component";
import {SupplierDiscountSelectComponent} from "./supplier-discount-select/supplier-discount-select.component";
import {DiscountTypeSelectComponent} from "./discount-type-select/discount-type-select.component";


// https://angular.io/styleguide#!#04-10
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    //DatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgSelectModule,
    NonEmptyListValidatorDirective,
    //DragDropModule,
    //AngularMultiSelectModule
  ],
    providers: [
        ColorsService
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        SortByKeyPipe,
        ImagePreview,
        ToggleButtonComponent,
        CompanySelectComponent,
        NominativeSelectComponent,
        ProjectSelectComponent,
        CustOrderSelectComponent,
        SpecificationsBuyerSelectComponent,
        SpecificationsItemSelectComponent,
        ListSelectComponent,
        HeadquarterSelectComponent,
        PaymentSelectComponent,
        VatRateSelectComponent,
        ItemSelectComponent,
        EmailFormComponent,
        NoteRegistrationComponent,
        UploaderComponent,
        StdDialogComponent,
        EnumSelectComponent,
        PageHeaderComponent,
        SupplierDiscountSelectComponent,
        DiscountTypeSelectComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        //DatepickerModule,
        BsDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
        FlotDirective,
        SparklineDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        SortByKeyPipe,
        ImagePreview,
        //DragDropModule,
        ToggleButtonComponent,
        CompanySelectComponent,
        NominativeSelectComponent,
        ProjectSelectComponent,
        CustOrderSelectComponent,
        SpecificationsBuyerSelectComponent,
        SpecificationsItemSelectComponent,
        HeadquarterSelectComponent,
        PaymentSelectComponent,
        VatRateSelectComponent,
        ListSelectComponent,
        NonEmptyListValidatorDirective,
        ItemSelectComponent,
        EmailFormComponent,
        NoteRegistrationComponent,
        UploaderComponent,
        StdDialogComponent,
        EnumSelectComponent,
        PageHeaderComponent,
        SupplierDiscountSelectComponent,
        DiscountTypeSelectComponent,
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}
